import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import HotelExtrasTable from "../../components/hotelExtras/HotelExtrasTable";

const HotelExtras = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <HotelExtrasTable />
        </WrapperSection>
    );
};

export default HotelExtras;
